// import axios from 'axios';
import api from '../lib/api';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';
const API_BASE = `${API_BASE_URL}/gpu-instances`;


export interface GpuProvider {
  id: string;
  name: string;
  type: string;
  isActive: boolean;
  createdAt: string;
  _count?: {
    instances: number;
  };
}

export interface GpuInstance {
  id: string;
  name: string;
  agentType: 'training' | 'host';
  status: string;
  gpuType: string;
  numGpus: number;
  pricePerHour: number;
  totalCost: number;
  sshHost: string;
  sshPort: number;
  trainingStatus?: string;
  currentEpoch?: number;
  totalEpochs?: number;
  trainLoss?: number;
  apiEndpoint?: string;
  requestCount?: number;
  avgLatencyMs?: number;
  createdAt: string;
  provider?: GpuProvider;
}

export interface GpuOffer {
  id: number;
  machine_id: number;
  gpu_name: string;
  num_gpus: number;
  cpu_cores: number;
  ram_gb: number;
  disk_space: number;
  dph_total: number;
  dlperf: number;
  reliability: number;
  datacenter: string;
}

export const gpuInstancesApi = {
  // Provider management
  createProvider: (data: { type: string; apiKey: string; sshKey?: string }) =>
    api.post(`${API_BASE}/providers`, data),

  getProviders: () =>
    api.get<GpuProvider[]>(`${API_BASE}/providers`),

  deleteProvider: (id: string) =>
    api.delete(`${API_BASE}/providers/${id}`),

  updateProvider: (id: string, data: { apiKey?: string; sshKey?: string }) =>
    api.patch(`${API_BASE}/providers/${id}`, data),

  // Marketplace
  searchOffers: (filters?: {
    gpuName?: string;
    numGpus?: number;
    maxPrice?: number;
    minDlperf?: number;
  }) =>
    api.get<GpuOffer[]>(`${API_BASE}/marketplace/search`, { params: filters }),

  // Instance management
  createInstance: (data: {
    agentType: 'training' | 'host';
    name: string;
    purpose?: string;
    offerId: number;
    dockerImage?: string;
    diskGb?: number;
  }) =>
    api.post<GpuInstance>(`${API_BASE}`, data),

  listInstances: (agentType?: 'training' | 'host') =>
    api.get<GpuInstance[]>(`${API_BASE}`, {
      params: agentType ? { agentType } : undefined,
    }),

  getInstance: (id: string) =>
    api.get<GpuInstance>(`${API_BASE}/${id}`),

  startInstance: (id: string) =>
    api.post(`${API_BASE}/${id}/start`),

  stopInstance: (id: string) =>
    api.post(`${API_BASE}/${id}/stop`),

  destroyInstance: (id: string) =>
    api.delete(`${API_BASE}/${id}`),

  syncInstances: (providerId?: string) =>
    api.post(`${API_BASE}/sync`, {}, { params: providerId ? { providerId } : undefined }),
};
